export const COM_PREVIEW = "https://via.placeholder.com/121";
